import React, { useCallback, useEffect, useRef, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
	ActivityIndicator,
	Linking,
	Platform,
	StyleSheet,
	View,
} from "react-native";
import ModalInfo from "../components/ModalInfo";
import { CustomContext } from "../contexts/custom-context";
import { HIDDEN_LOGIN_RECAPTCHA_ACTION, hiddenLogin } from "../services/hiddenLogin";
import { connectSocket } from "../services/socket";
import {
	RECAPTCHA_ERROR_MESSAGE,
	RECAPTCHA_ERROR_TITLE,
	isRecaptchaError,
} from "../utils/recaptcha";

const RECAPTCHA_LOAD_TIMEOUT_MS = 10_000;

export const CustomProvider: React.FC = ({ children }: any) => {
	const [loading, setLoading] = useState(true);
	const [store, setStore] = useState("");
	const [showSecurityCheckError, setShowSecurityCheckError] = useState(false);
	const isLoggedInRef = useRef(false);
	const { executeRecaptcha } = useGoogleReCaptcha();

	const loginHidden = useCallback(() => {
		hiddenLogin(async () => executeRecaptcha?.(HIDDEN_LOGIN_RECAPTCHA_ACTION))
			.then(() => {
				isLoggedInRef.current = true;
			})
			.catch((error) => {
				if (isRecaptchaError(error)) {
					setShowSecurityCheckError(true);
					return;
				}
				console.error("Erro no login automático:", error);
			});
	}, [executeRecaptcha]);

	useEffect(() => {
		getStore();
		setTimeout(() => setLoading(false), 2000);
	}, []);

	useEffect(() => {
		if (executeRecaptcha && !isLoggedInRef.current) {
			loginHidden();
		}
	}, [executeRecaptcha, loginHidden]);

	useEffect(() => {
		if (executeRecaptcha) return undefined;

		const timer = setTimeout(() => {
			if (!isLoggedInRef.current) setShowSecurityCheckError(true);
		}, RECAPTCHA_LOAD_TIMEOUT_MS);

		return () => clearTimeout(timer);
	}, [executeRecaptcha]);

	const onRetrySecurityCheck = () => {
		setShowSecurityCheckError(false);
		if (!executeRecaptcha && Platform.OS === "web") {
			window.location.reload();
			return;
		}
		loginHidden();
	};

	const getStore = async () => {
		const urlbase = (await Linking.getInitialURL()) || "";
		const url = new URL(urlbase);
		const storeId = url.searchParams.get("store") as string;
		if (!storeId) return
		setStore(storeId);
	};

	const styles = StyleSheet.create({
		container: {
			flex: 1,
			justifyContent: "center",
		},
	});


	useEffect(() => {
		connectSocket();
	}, [])

	return (
		<CustomContext.Provider
			value={{
				storeId: store,
				currentLatitude: "0",
				currentLongitude: "0",
				setStore: setStore
			}}
		>
			<ModalInfo
				isOpen={showSecurityCheckError}
				setIsOpen={setShowSecurityCheckError}
				title={RECAPTCHA_ERROR_TITLE}
				description={RECAPTCHA_ERROR_MESSAGE}
				buttonConfirmationText="Tentar novamente"
				action={onRetrySecurityCheck}
				testID="security_check_modal"
			/>
			{loading ? (
				<View style={styles.container}>
					<ActivityIndicator
						size="large"
						color="#30374A"
					/>
				</View>
			) : (
				children
			)}
		</CustomContext.Provider>
	);
};
